/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Access_EntireInputs */



/**
* | output |
* | --- |
* | "Entire project" |
*
* @param {Team_Share_Access_EntireInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_access_entire = /** @type {((inputs?: Team_Share_Access_EntireInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Access_EntireInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entire project")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entire project")
	if (locale === "it") return /** @type {LocalizedString} */ ("Entire project")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Entire project")
	if (locale === "es") return /** @type {LocalizedString} */ ("Entire project")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Entire project")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Entire project")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Entire project")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Entire project")
	return /** @type {LocalizedString} */ ("Entire project")
});